import React, {createContext, useContext, useState} from 'react';
import {sccjsonTemplate} from '../constants/jsonTemplates';
import {isArray} from 'lodash';

const JsonEditorContext = createContext();

export const JsonEditorProvider = ({children}) => {
  const [currentJsonText, setCurrentJsonText] = useState(JSON.stringify(sccjsonTemplate, null, 2));

  const updateCurrentJsonText = (newJsonText) => {
    setCurrentJsonText(newJsonText);
  };

  const validateCurrentJson = () => {
    try {
      JSON.parse(currentJsonText);
      return true;
    } catch {
      return false;
    }
  };

  const getDeviceNames = () => {
    const deviceNames = [];
    const {devices} = JSON.parse(currentJsonText);
    for (const deviceType in devices) {
      if (!isArray(devices[deviceType])) {
        deviceNames.push({deviceName: devices[deviceType].name, deviceType});
      } else if (devices[deviceType].length > 0) {
        for (let i = 0; i < devices[deviceType].length; i++) {
          deviceNames.push({
            deviceName: devices[deviceType][i].name,
            deviceType,
            deviceSubType: devices[deviceType][i].deviceType,
          });
        }
      }
    }
    return deviceNames;
  };

  return (
    <JsonEditorContext.Provider value={{
      currentJsonText,
      setCurrentJsonText,
      updateCurrentJsonText,
      validateCurrentJson,
      getDeviceNames,
    }}>
      {children}
    </JsonEditorContext.Provider>
  );
};

export const useJsonEditor = () => {
  const context = useContext(JsonEditorContext);
  if (!context) throw new Error('useJsonEditor must be used within a JsonEditorProvider');
  return context;
};

